// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2324": "aa022e97","3473": "c10b5a82","8561": "f9cad78a",}[chunkId] + ".css"
}